
const translations = {
    "Notice!": "Notice!",
    "Are you sure that you want to delete this?": "Are you sure that you want to delete this?",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Min": "Min",
    "Max": "Max",
    "Before": "Before",
    "After": "After",
    "w": "w",
    "week": "week",
    "weeks": "weeks",
    "d": "d",
    "day": "day",
    "days": "days",
    "Due date": "Due date",
    "Start date": "Start date",
    "Internal date": "Internal date",
    "Notes": "Notes",
    "Document": "Document",
    "Email": "Email",
    "Billing": "Billing",
    "Add": "Add",
    "Archived": "Archived",
    "Cancelled": "Cancelled",
    "Active": "Active",
    "Inactive": "Inactive",
    "Client company": "Client company",
    "General info": "General info",
    "Digitisation of client documents": "Digitization of client documents",
    "Client portal": "Client portal",
    "Documents": "Documents",
    "Members": "Members",
    "Preferences": "Preferences",
    "Yes": "Yes",
    "No": "No",
    "Total hours": "Total hours",
    "Extra hours": "Extra hours",
    "Client": "Client",
    "Tasks": "Tasks",
    "Disable Uku’s task templates": "Disable Uku’s task templates",
    "Set the estimation as time when the exact value is not entered": "Set the estimation as the time, if the exact value is not entered",
    "Checklist must be completed to finish the task": "Checklist must be completed to finish the task",
    "Disable topic management for members": "Disable topic management for members",
    "Disable time edit for members": "Disable time edit for members",
    "Allow time entries in future": "Allow time entries in future",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Clients",
    "Disable adding new clients for members": "Disable adding new clients for members",
    "Only administrators can edit documents": "Only administrators can edit documents",
    "Allow digitisation of client documents": "Allow digitization of client documents",
    "Use my Microsoft account": "Use my Microsoft account",
    "Disconnect my Microsoft account": "Disconnect my Microsoft account",
    "Connect my Microsoft account": "Connect my Microsoft account",
    "Use my google account": "Use my Google account",
    "Connect my google account": "Connect my google account",
    "Disconnect my google account": "Disconnect my google account",
    "Use my Xero account": "Use my Xero account",
    "Connect my Xero account": "Connect my Xero account",
    "Disconnect my Xero account": "Disconnect my Xero account",
    "Emails": "Emails",
    "Daily agenda": "Daily agenda",
    "Unread notifications": "Unread notifications",
    "Task assigned to me": "Task assigned to me",
    "Weekly summary": "Weekly summary",
    "Monthly summary": "Monthly summary",
    "Updates and tips": "Updates and tips",
    "Overdue": "Overdue",
    "1 day": "1 day",
    "1 day overdue": "1 day overdue",
    "{0} days": "{0} days",
    "{0} days overdue": "{0} days overdue",
    "{0} minute ago": "{0} minute ago",
    "{0} minutes ago": "{0} minutes ago",
    "{0} hour ago": "{0} hour ago",
    "{0} hours ago": "{0} hours ago",
    "Sunday": "Sunday",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sun": "Sun",
    "Mon": "Mon",
    "Tue": "Tue",
    "Wed": "Wed",
    "Thu": "Thu",
    "Fri": "Fri",
    "Sat": "Sat",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dec",
    "Today": "Today",
    "Yesterday": "Yesterday",
    "Day": "Day",
    "Days": "Days",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Weekly {0}",
    "Every {0}. week {1}": "Every {0}. week {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Monthly {0}. d",
    "Every {0}. month {1}. d": "Every {0}. month {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Quarterly {0}. month {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Every {0}. quarter {1}. month {2}. d",
    "{0}. month {1}. d": "{0}. month {1}. d",
    "Yearly {0}": "Yearly {0}",
    "Every {0}. year {1}": "Every {0}. year {1}",
    "Mo": "Mo",
    "Tu": "Tu",
    "We": "We",
    "Th": "Th",
    "Fr": "Fr",
    "Sa": "Sa",
    "Su": "Su",
    "and": "and",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "before",
    "after": "after",
    "Project": "Project",
    "Quarter": "Quarter",
    "Add logo": "Add logo",
    "Add your photo": "Add your photo",
    "Adding file failed": "Adding file failed",
    "Please check the file.": "Please check the file.",
    "You can only add pictures.": "You can only add pictures.",
    "Error": "Error",
    "Create new topic": "Create new topic",
    "Name": "Name",
    "Close": "Close",
    "Find topic...": "Find topic...",
    "New topic": "New topic",
    "Invalid format": "Invalid format",
    "Demo company account": "Demo company account",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demo account will be deleted later. Use this for testing purposes only!",
    "Subscribe": "Subscribe",
    "Start demo": "Start demo",
    "End demo": "End demo",
    "Free trial is expired - {0}": "Free trial has expired - {0}",
    "Free trial {1} {2} left - {0}": "Free trial {1} {2} left - {0}",
    "Add time": "Add time",
    "Billable": "Billable",
    "Date": "Date",
    "Start": "Start",
    "End": "End",
    "Duration": "Duration",
    "Split duration equally": "Split duration equally",
    "Required field": "Required field",
    "Members list": "Members list",
    "Edit fields": "Show fields",
    "Maximum number of selected columns has been exceeded": "Maximum number of selected columns has been exceeded",
    "If you want to add a new column to the report, please remove an existing one first.": "If you want to add a new column to the report, please remove an existing one first.",
    "Snooze until...": "Snooze until...",
    "Select date & time": "Select date & time",
    "Tomorrow": "Tomorrow",
    "Later this week": "Later this week",
    "Next week": "Next week",
    "Add task": "Add task",
    "Checklist": "Checklist",
    "Start timer": "Start timer",
    "Add an item": "Add an item",
    "Add checklist item": "Add checklist item",
    "Convert to a task": "Convert to a task",
    "Delete": "Delete",
    "Delegate to...": "Delegate to...",
    "Please select tasks from the same account": "Please select tasks from the same account",
    "Follow": "Follow",
    "Expand sidebar": "Expand sidebar",
    "Nicely done!": "Nicely done!",
    "You've finished all your tasks, take a second to recharge": "You've finished all your tasks, take a second to recharge",
    "Search tasks...": "Search tasks...",
    "Search": "Search",
    "select/unselect all": "select/unselect all",
    "Add new client": "Add new client",
    "Account": "Account",
    "Client name": "Client name",
    "Select client": "Select client",
    "New client": "New client",
    "Must be an integer": "Must be an integer",
    "Must be a number": "Must be a number",
    "Dashboard": "Dashboard",
    "Calendar": "Calendar",
    "Report": "Report",
    "Monitoring": "Monitoring",
    "Suppliers": "Suppliers",
    "Events": "Events",
    "Projects": "Projects",
    "Help": "Help",
    "Invite a friend": "Invite a friend",
    "Settings & Apps": "Settings & Apps",
    "Profile": "Profile",
    "Collapse menu": "Collapse menu",
    "Expand menu": "Expand menu",
    "Are you sure to delete this attachment?": "Are you sure you want to delete this attachment?",
    "Select": "Select",
    "Edit contacts": "Edit contacts",
    "Add member": "Add member",
    "Add note": "Add note",
    "Open": "Open",
    "Reports": "Reports",
    "Billing notes": "Billing notes",
    "Pinned notes": "Pinned notes",
    "Sub-companies": "Sub-companies",
    "Contacts": "Contacts",
    "Event info": "Event info",
    "Project info": "Project info",
    "Summary": "Summary",
    "Task": "Task",
    "Time": "Time",
    "Collapse sidebar": "Collapse sidebar",
    "Client Overview": "Client Overview",
    "Event Overview": "Event Overview",
    "Project Overview": "Project Overview",
    "Edit client": "Edit client",
    "Edit event": "Edit event",
    "Edit project": "Edit project",
    "Show all": "Show all",
    "Collapse": "Collapse",
    "by": "by",
    "View all": "View all",
    "Copied to clipboard": "Copied to clipboard",
    "Client portal invite sent on {0}": "Client portal invite sent on {0}",
    "Client portal invite has not been sent": "Client portal invite has not been sent",
    "Resend invite": "Resend invite",
    "Send invite": "Send invite",
    "Invite sent": "Invite sent",
    "Add company event": "Add company event",
    "Company": "Company",
    "Info": "Info",
    "Holiday": "Holiday",
    "All day(s)": "All day(s)",
    "End date": "End date",
    "From": "From",
    "Until": "Until",
    "Hours": "Hours",
    "Link": "Link",
    "Save": "Save",
    "Are you sure that you want to delete this company calendar event?": "Are you sure that you want to delete this company calendar event?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Add new role",
    "New role": "New role",
    "Access enabled": "Access enabled",
    "Waiting for files": "Waiting for files",
    "Uploaded": "Uploaded",
    "Uploading...": "Uploading...",
    "Client members": "Client members",
    "Email settings": "Email settings",
    "Or connect new email address": "Or connect new email address",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Connect with Microsoft Exchange or other email server (SMTP)",
    "Test email sent": "Test email sent",
    "Email address": "Email address",
    "Reply address": "Reply address",
    "Sender name": "Sender name",
    "Who can use?": "Who can use?",
    "Client default address": "Client default address",
    "Invalid e-mail": "Invalid e-mail",
    "Role": "Role",
    "E-mail": "Email",
    "Mobile phone": "Mobile phone",
    "Work phone": "Work phone",
    "Language": "Language",
    "Birthday": "Birthday",
    "Are you sure to delete this contact?": "Are you sure you want to delete this contact?",
    "Manage contact fields": "Manage contact fields",
    "Administrative Assistant": "Administrative Assistant",
    "Board member": "Board member",
    "CEO": "CEO",
    "Add contact": "Add contact",
    "Contact person": "Contact person",
    "Leave page?": "Are you sure you want to leave the page?",
    "Changes that you made may not be saved": "Changes that you made may not be saved",
    "Leave": "Leave",
    "Validate tasks": "Validate tasks",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.",
    "Continue": "Continue",
    "Super! We're importing your clients...": "Super! We're importing your clients...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.",
    "Please wait...": "Please wait...",
    "Setup API keys": "Setup API keys",
    "You have two options": "You have two options",
    "how to setup API keys": "How to set up API keys",
    "Custom import": "Custom import",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "To import clients and volume of work from !INTEGRATION, Uku needs an !INTEGRATION API key for every client.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:",
    "(it takes a lot of time)": "(it takes a lot of time)",
    "Import Clients": "Add & update data",
    "Country": "Country",
    "Please choose your country": "Please choose your country",
    "Password": "Password",
    "Start import": "Start import",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Insert !INTEGRATION login details (it’s secure) to give one-time access to import clients and API keys. Please note that you will be logged out from !INTEGRATION in other browsers.",
    "Update invoice status": "Update invoice status",
    "Update now": "Update now",
    "Daily @ 14:00": "Daily @ 14:00",
    "Daily @ 18:00": "Daily @ 18:00",
    "Updating invoice statuses, please wait...": "Updating invoice statuses, please wait...",
    "Your import is ready": "Client import needs your confirmation",
    "In the final step you need to confirm the clients you want to add to uku": "In the final step you need to confirm the clients you want to add to uku",
    "Let's go": "Let's go",
    "Import again": "Import again",
    "Do you have new clients to import?": "Do you have new clients to import?",
    "Yes, i do": "Yes, I do",
    "View last import": "View last import",
    "Email server": "Email server",
    "Email provider": "Email provider",
    "Host": "Host",
    "Port": "Port",
    "Security": "Security",
    "Sender email": "Sender email",
    "Username": "Username",
    "Test connection": "Test connection",
    "How to set up": "How to set up",
    "Only administrators can activate the app": "Only administrators can activate the app",
    "You are in the waiting list": "You are in the waiting list",
    "We onboard all applicants one by one": "Mark your interest, and we will notify you when the app is available for testing",
    "Connected": "Connected",
    "Activated": "Activated",
    "Join waiting list": "Join waiting list",
    "Activate": "Activate",
    "Unsubscribe from waiting list": "Unsubscribe from waiting list",
    "Deactivate app": "Deactivate app",
    "Disconnect": "Disconnect",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "Email not delivered",
    "Sent, but fallback to Uku email": "Sent by Uku due to problems with your email setup",
    "Unknown error": "Unknown error",
    "to": "to",
    "automatically": "automatically",
    "in any minute": "at any minute",
    "on {0},": "on {0},",
    "or": "or",
    "Send now": "Send now",
    "Uku will no longer send email": "Uku will no longer send email",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku will send <span class='subtitle-2'>email</span>",
    "__From_email": "From",
    "Set up email": "Set up email",
    "Client default": "Client default",
    "Subject": "Subject",
    "Edit email": "Edit email",
    "Template": "Template",
    "Cc": "Cc",
    "Bcc": "Bcc",
    "__To_email": "To",
    "__Cc_email": "Cc",
    "__Bcc_email": "Bcc",
    "Add template": "Add template",
    "Add automation": "Add automation",
    "Add placeholder": "Add placeholder",
    "Format text": "Format text",
    "Add attachment": "Add attachment",
    "Send": "Send",
    "Save automation": "Save automation",
    "Choose email template": "Choose email template",
    "All languages": "All languages",
    "No templates found.": "No templates found.",
    "Edit email template": "Edit email template",
    "Are you sure you want to delete this template? Some tasks will be affected": "Are you sure you want to delete this template? Some tasks will be affected",
    "Are you sure you want to delete this template?": "Are you sure you want to delete this template?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Are you sure you want to save this template? The following tasks will be affected:",
    "Template name": "Template name",
    "Edit template": "Edit template",
    "Send email": "Send email",
    "on": "on",
    "Ok": "Ok",
    "Supplier": "Supplier",
    "Event": "Event",
    "Contact": "Contact",
    "Validation failed": "Validation failed",
    "Saving supplier failed": "Saving supplier failed",
    "Saving client failed": "Saving client failed",
    "Saving project failed": "Saving project failed",
    "several values": "several values",
    "values": "values",
    "is": "is",
    "Add filter": "Add filter",
    "Update": "Update",
    "forever": "forever",
    "Last week": "Last week",
    "This week": "This week",
    "Last month": "Last month",
    "This month": "This month",
    "Next month": "Next month",
    "Last year": "Last year",
    "This year": "This year",
    "This quarter": "This quarter",
    "Next quarter": "Next quarter",
    "Last quarter": "Last quarter",
    "Client group": "Client group",
    "Topic": "Topic",
    "Member": "Member",
    "Primary member": "Primary member",
    "Client status": "Client status",
    "Active clients": "Active clients",
    "Inactive clients": "Inactive clients",
    "All": "All",
    "Project status": "Project status",
    "Member status": "Member status",
    "Active members": "Active members",
    "Limited members": "Limited members",
    "Inactive members": "Inactive members",
    "Contract status": "Contract status",
    "Active contracts": "Active contracts",
    "Pending contracts": "Pending contracts",
    "Finished contracts": "Finished contracts",
    "Contract template": "Contract template",
    "Payment recurrence": "Payment recurrence",
    "Yearly": "Yearly",
    "Monthly": "Monthly",
    "Trial": "Trial",
    "Region": "Region",
    "Field": "Field",
    "All tasks": "All tasks",
    "Todo": "To do",
    "Not done": "Not done",
    "Done": "Done",
    "Delayed": "Delayed",
    "Important": "Important",
    "Extra work": "Extra work",
    "I Follow": "I Follow",
    "Commented": "Commented",
    "Tracked time": "Tracked time",
    "Estimated": "Estimated",
    "Recurring task": "Recurring task",
    "Last import": "Last import",
    "Period": "Period",
    "Client search": "Client search",
    "Voucher": "Voucher",
    "Company status": "Company status",
    "Deleted": "Deleted",
    "All status": "All status",
    "Payment gateway": "Payment gateway",
    "All gateways": "All gateways",
    "Uku manually": "Uku manually",
    "Braintree": "Braintree",
    "Plan status": "Plan status",
    "All plans": "All plans",
    "Paid": "Paid",
    "Paid churn": "Paid churn",
    "Trial churn": "Trial churn",
    "Plan period": "Plan period",
    "All periods": "All periods",
    "Monthly plan": "Monthly plan",
    "Yearly plan": "Yearly plan",
    "Company search": "Company search",
    "User search": "User search",
    "Name key search": "Name key search",
    "None filter": "None",
    "OK": "OK",
    "Start date cannot be later than due date": "Start date cannot be later than due date",
    "tasks": "tasks",
    "task(s) had errors": "task(s) have errors",
    "tasks selected": "tasks selected",
    "Postpone": "Postpone",
    "Mark done": "Mark done",
    "Hide multiselect": "Hide multiselect",
    "Delete task(s)": "Delete task(s)",
    "All of the data related to the task will be deleted": "All of the data related to the task will be deleted",
    "Some tasks include other people. Are you sure you want to delete?": "Some tasks include other people. Are you sure you want to delete?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Time has been tracked to some of the selected activities. Are you sure you want to delete?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?",
    "task(s) were not marked done": "task(s) were not marked done",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Please check that the checklist is complete, the time has been entered, and the task is assigned to you",
    "task(s) were not deleted": "task(s) were not deleted",
    "task(s) time was not updated": "task(s) time was not updated",
    "Please make sure that you can add time to task": "Please make sure that you can add time to task",
    "invoice table row": "invoice table row",
    "invoice table row(s) had errors": "invoice table row(s) have errors",
    "invoice table row(s) selected": "invoice table row(s) selected",
    "Create": "Create",
    "Mark paid": "Mark as paid",
    "Send to client": "Send to client",
    "Recalculate": "Recalculate",
    "Export to {0}": "Export to {0}",
    "Update Status from {0}": "Update Status from {0}",
    "Void invoice": "Void invoice",
    "Delete invoice": "Delete invoice",
    "Restore invoice": "Restore invoice",
    "Mark unpaid": "Mark unpaid",
    "Invoices": "Invoices",
    "Download to Excel": "Download to Excel",
    "Revenue split": "Revenue split",
    "Tax": "Tax",
    "Description": "Description",
    "Percent": "Percent",
    "Integration Id": "Integration Id",
    "Integration Code": "Integration Code",
    "Name on invoice": "Name on invoice",
    "Restore": "Restore",
    "Archive": "Archive",
    "Hide": "Hide",
    "Are you sure?": "Are you sure?",
    "Invoice seller": "Invoice seller",
    "Company name": "Company name",
    "Address": "Address",
    "Company number": "Company number",
    "Tax number": "Tax number",
    "Bank": "Bank",
    "IBAN": "IBAN",
    "Delete logo": "Delete logo",
    "Upload logo file": "Upload logo file",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Import finished!": "Import finished!",
    "Failed to import {0} records": "Failed to import {0} records",
    "Download report": "Download report",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Result: added {0}, updated {1}, skipped {2}, failed to import {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Result: added {0}, updated {1}, skipped {2}",
    "What’s next?": "What’s next?",
    "To work effectively with your client base, complete the following steps:": "To work effectively with your client base, complete the following steps:",
    "Read more ›": "Read more ›",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Next you will only see active imported clients. To see all clients, remove “Last import” filter.",
    "View clients": "View clients",
    "Add <b>primary member</b> to every client.": "Add <b>primary member</b> to every client.",
    "Add <b>task plan</b> to automate recurring tasks.": "Add <b>task plan</b> to automate recurring tasks.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Setup automatic monthly summary under {0} app in Uku to import volume of work.",
    "Title": "Title",
    "Field type": "Field type",
    "Field name": "Field name",
    "Client section": "Client section",
    "Choices": "Choices",
    "Type each choice on a separate line": "Type each choice on a separate line",
    "Required": "Required",
    "For all topics": "For all topics",
    "For specific topics": "For specific topics",
    "Topics": "Topics",
    "Non-billable": "Non-billable",
    "Edit task custom field": "Edit task custom field",
    "Add task custom field": "Add task custom field",
    "Edit client custom field": "Edit client custom field",
    "Add client custom field": "Add client custom field",
    "Choice {0}": "Choice {0}",
    "Are you sure that you want to delete this custom field?": "Are you sure you want to delete this custom field?",
    "Warning!": "Warning!",
    "This custom field is in use. Do you wish to archive it?": "This custom field is in use. Do you want to archive it?",
    "Reconnect": "Reconnect",
    "Send test email": "Send test email",
    "Email address or username": "Email address or username",
    "Other": "Other",
    "Set default email server for company": "Set default email server for company",
    "My default email": "My default email",
    "Depends on": "Depends on",
    "Todo - Blocking": "To do - Blocking",
    "In progress - Blocking": "In progress - Blocking",
    "In progress": "In progress",
    "Client code": "Client code",
    "Primary user": "Primary member",
    "Added date": "Added date",
    "Updated": "Updated",
    "Contract count": "Contract count",
    "Integration": "Integration",
    "No data available": "No data available",
    "No results found": "No results found",
    "Loading": "Loading",
    "Sort by": "Sort by",
    "{0}-{1} of {2}": "{0}-{1} of {2}",
    "Rows per page": "Rows per page",
    "Ongoing": "Ongoing",
    "important": "Important",
    "Read more": "Read more",
    "Add to previous time entry": "Add to previous time entry",
    "Add to next time entry": "Add to next time entry",
    "Add new task": "Add new task",
    "Cut previous time entry": "Cut previous time entry",
    "Cut next time entry": "Cut next time entry",
    "Missing time entry": "Missing time entry",
    "Overlapping time entries": "Overlapping time entries",
    "Member from custom fields": "Member from custom fields",
    "Delegated to": "Delegated to",
    "Delegated by": "Delegated by",
    "Visible members": "Visible members",
    "Member type": "Member type",
    "Groups": "Groups",
    "Custom field": "Custom field",
    "Contact search": "Contact search",
    "Task start": "Task start",
    "Task due": "Task due",
    "Task finish": "Task finish",
    "Custom date": "Custom date",
    "Never": "Never",
    "Referral status": "Referral status",
    "Invited": "Invited",
    "Registered": "Registered",
    "Earned": "Earned",
    "Agreed work is still expected": "Agreed work is still expected",
    "Accepted flextime": "Flextime accepted",
    "Declined flextime": "Flextime declined",
    "Cancelled flextime": "Flextime cancelled",
    "Updated flextime": "Flextime updated",
    "Calendar deleted": "Vacation deleted",
    "Calendar created": "Vacation requested",
    "Calendar approved": "Vacation approved",
    "Calendar declined": "Vacation rejected",
    "Calendar updated": "Vacation updated",
    "Flextime balance updated": "Flextime balance updated",
    "Flextime": "Flextime",
    "Vacation": "Vacation",
    "Balance": "Balance",
    "Comment": "Comment",
    "History": "History",
    "Action": "Action",
    "Who": "Who",
    "Take a vacation or mark an absence": "Take a vacation or mark an absence",
    "Away": "Away",
    "Flextime bonus": "Flextime bonus",
    "Approver": "Approver",
    "Vacation available": "Vacation available",
    "Type": "Type",
    "Reduce agreed working hours": "Reduce agreed working hours",
    "Reject": "Reject",
    "Approve": "Approve",
    "away_type_Away": "Away",
    "Sick leave": "Sick leave",
    "Parental leave": "Parental leave",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Total",
    "Settings": "Settings",
    "Work on holidays": "Work on holidays",
    "Get {0} in cash for every referral who becomes a Uku client.": "Get {0} in cash for every referral who becomes a Uku client.",
    "Copy your invite link": "Copy your invite link",
    "Hide message": "Hide message",
    "View message": "View message",
    "Your statistics": "Your statistics",
    "Copy message": "Copy message",
    "How it works": "How it works",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "After your referral becomes a paying Uku client, we send you a {0} gift card.",
    "More ways to earn cash": "More ways to earn cash",
    "referral_email_content": "Hi, {{friend_name}}!<br><br>I’ve been using Uku’s modern task management and CRM software myself, and I think you’ll like it too. Here are a few features I use regularly:<br>* Task automation – works like a personal assistant<br>* Time tracking – simpler and more accurate than Toggl<br>* Client management – all the essential info in one place<br>* Invoicing – automatic and fast<br>* Client agreement monitoring – keeps all agreements in check<br><br>With my referral, you’ll get a 30-day free trial and free team training. You can learn more here: {{learn_more_link}}<br><br>{{accept_invite_link}} (Accept the invitation and give it a try!)<br><br>Best regards,<br>{{your_name}}",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>",
    "Expand": "Expand",
    "Wait until event status": "Wait until event status",
    "Wait until project status": "Wait until project status",
    "Week(s)": "Week(s)",
    "Day(s)": "Day(s)",
    "Rule": "Rule",
    "Depends on event": "Depends on event",
    "Depends on project": "Depends on project",
    "Due date in": "Due date in",
    "Status": "Status",
    "Select event": "Select event",
    "Select project": "Select project",
    "Find event...": "Find event...",
    "Find project...": "Find project...",
    "Custom recurrence": "Recurrence",
    "Every": "Every",
    "In case of holiday": "In case of holiday",
    "Set time": "Set time",
    "Start time": "Start time",
    "Repeat from": "Repeat from",
    "Previous repeat from: {0}": "Previous repeat from: {0}",
    "On date": "On date",
    "Plus days": "Plus days",
    "Due date time": "Due time",
    "Remove recurrence": "Remove recurrence",
    "Repeat": "Repeat",
    "month": "month",
    "quarter": "quarter",
    "year": "year",
    "1st month": "1st month",
    "2nd month": "2nd month",
    "3rd month": "3rd month",
    "Day {0}": "Day {0}",
    "Show before": "Show before",
    "Keep the day": "Keep the day",
    "Show after": "Show after",
    "From start date": "From start date",
    "From beginning of the month": "From beginning of the month",
    "All days (Mon to Sun)": "All days (Mon to Sun)",
    "Mon to Fri (incl. holidays)": "Mon to Fri (incl. holidays)",
    "Mon to Fri (excl. holidays)": "Mon to Fri (excl. holidays)",
    "1st": "1st",
    "2nd": "2nd",
    "3rd": "3rd",
    "Does not repeat": "Does not repeat",
    "Daily": "Daily",
    "Weekly on {0}": "Weekly on {0}",
    "Monthly on day {0}": "Monthly on day {0}",
    "Quarterly on {0} month {1} day": "Quarterly on {0} month {1} day",
    "Yearly on {0} {1}": "Yearly on {0} {1}",
    "Custom...": "Custom…",
    "Incorrect time": "Incorrect time",
    "Add repeat": "Add recurrence",
    "Email added to queue": "Email added to queue",
    "Communication timeline": "Communication timeline",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Activate Email App in App Store to send automated emails and view your past and future communication in one place.",
    "Go to App Store": "Set up your app",
    "Unknown": "Unknown",
    "<b>Email</b> from": "<b>Email</b> from",
    "To": "To",
    "Planned": "Planned",
    "Automated emails scheduled to be sent in the future": "Emails scheduled to be sent during the next 45 days",
    "Send e-mail": "Send e-mail",
    "Template unlinked": "Template unlinked",
    "Icon": "Icon",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Visible",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Company default",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Find member...",
    "I'll take it": "I’ll take it",
    "Remove me": "Remove me",
    "Remove from task": "Remove from task",
    "Learn more": "Learn more",
    "Company settings edit is disabled by owner": "Company settings are locked by owner",
    "<b>Exported</b> {0} to {1}": "<b>Exported</b> {0} to {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Paid {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Annulled</b> {0}",
    "Do you wish to mark the task done for everyone?": "Do you wish to mark the task done for everyone?",
    "No, remove me": "No, remove me",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Task won’t be marked done, but user will be removed from the assignees and added to the followers of the task",
    "Invalid email": "Invalid email",
    "Accounting": "Accounting",
    "General": "General",
    "Advertising / Marketing/ PR": "Advertising / Marketing/ PR",
    "Architecture": "Architecture",
    "Construction": "Construction",
    "Consulting - IT, software": "Consulting - IT, software",
    "Consulting - Management": "Consulting - Management",
    "Finance": "Finance",
    "Legal": "Legal",
    "Medicine / Pharmacy ": "Medicine / Pharmacy ",
    "Non-profit": "Non-profit",
    "Web design": "Web design",
    "Web development": "Web development",
    "Max 140 characters": "Max 140 characters",
    "Please complete the checklist": "Please complete the checklist",
    "It is required to mark all checklist items as done": "It is required to mark all checklist items as done",
    "Please enter time spent": "Please enter time spent",
    "Inserting time is essential for this client": "Inserting time is essential for this client",
    "Only me": "Only me",
    "Private": "Private",
    "Edit note": "Edit note",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Add additional information about the client, such as special agreements, passwords, etc.",
    "Edit": "Edit",
    "Workdays": "Workdays",
    "Workhours": "Workhours",
    "Weeks": "Weeks",
    "Clear filters": "Clear filters",
    "Save filters": "Save filters",
    "Expected": "Expected",
    "Estimation": "Estimation",
    "Do you also want to postpone the due date?": "Do you also want to postpone the due date?",
    "{0} week": "{0} week",
    "{0} weeks": "{0} weeks",
    "Vacations": "Vacations",
    "Holidays": "Holidays",
    "Tax dates": "Tax dates",
    "Accounting news": "Accounting news",
    "Company events": "Company events",
    "Member birthdays": "Member birthdays",
    "Contact birthdays": "Contact birthdays",
    "Group items": "Group items",
    "Don't group": "Don't group",
    "{0} away": "{0} away",
    "Member birthday | Member birthdays": "Member birthday | Member birthdays",
    "Contact birthday | Contact birthdays": "Contact birthday | Contact birthdays",
    "Contact birthday": "Contact birthday",
    "Member birthday": "Member birthday",
    "Are you sure you wish to delete this link?": "Are you sure you want to delete this link?",
    "Reference name": "Reference name",
    "Reference link": "Reference link",
    "Free trial": "Free trial",
    "Solo": "Solo",
    "Team": "Team",
    "Enterprise": "Enterprise",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome browser plugin for Uku to manage your tasks, clients and track time.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.",
    "Setup client groups, custom fields and modify your preferences.": "Setup client groups, custom fields and modify your preferences.",
    "test": "test",
    "Anti Money Laundering": "Anti-Money Laundering",
    "Setup your customer AML and get instant reminders when auditing is due.": "Setup your customer AML and get reminders when auditing is due.",
    "flextime_description": "Manage work-life balance with ease.",
    "Smart Accounts": "Smart Accounts",
    "Automatically imports work statistics from your accounting software.": "Automatically imports work statistics from your accounting software.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Speed up your client billing process with pricelists and smart contracts.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Visual report will tell you exactly how profitable or unprofitable your client is.",
    "Emailing description": "Send emails directly from Uku and automate recurring emails",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Import clients and automate your billing. Send all invoices to e-conomic with just four clicks.",
    "Xero": "Xero",
    "xero_description": "Import clients from Xero to Uku and automate your billing.",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Import clients from QuickBooks Online to Uku and automate your billing.",
    "Tripletex": "Tripletex",
    "tripletex_description": "Import clients from Tripletex to Uku and automate your billing.",
    "Scoro": "Scoro",
    "Export sales invoices.": "Export sales invoices.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Import clients from Fortnox to Uku and automate your billing.",
    "Magic button": "Magic button",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.",
    "With suppliers, you make your projects and partners management more efficient.": "With suppliers, you can make your projects and partners management more efficient.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Powerful and flexible project management serves diverse use cases and workflows.",
    "client_portal_app_description": "Client portal simplifies collaboration with clients. Securely receive documents, assign tasks, and share information.",
    "Chat": "Chat",
    "chat_app_description": "Enhance team collaboration, client communication, and overall efficiency with the Chat.",
    "Companies House": "Companies House",
    "companies_house_app_description": "Set up Companies House data for UK clients and get reminders when statements are due.",
    "documents_app_description": "Automatically synchronize all your files to your document repository.",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "Import your clients’ data from Freeagent to Uku.",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Connect and discover tools to help you manage your business.",
    "Subscribe now": "Subscribe now",
    "Compare plans": "Compare plans",
    "Add company": "Add company",
    "BETA": "BETA",
    "Setup": "Setup",
    "Power up": "Power up",
    "Integrations": "Integrations",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hi! Do you want to work with a team and use extra features? No problem, first add your company!",
    "Read more about Uku plans": "Read more about Uku plans",
    "Contact role": "Contact role",
    "Contact roles": "Contact roles",
    "Client groups": "Client groups",
    "Client fields": "Client fields",
    "Contact fields": "Contact fields",
    "View archive": "View archive",
    "Restore from archive": "Restore from archive",
    "Empty list": "Empty list",
    "Task fields": "Task fields",
    "task topics": "task topics",
    "Keep the task opened when starting the timer": "Keep the task open when starting the timer",
    "task templates": "task templates",
    "Author": "Author",
    "Duplicate": "Duplicate",
    "Uku task templates": "Uku task templates",
    "Are you sure that you want to delete this task template?": "Are you sure that you want to delete this task template?",
    "Templates": "Templates",
    "Overview": "Overview",
    "chat_app_overview_text": "<p class='title'>Uku Chat is a user-friendly and secure messaging tool tailored to streamline communication, collaboration, and task management.</p> <div class='body-2'><p>Key functionalities include:</p><ul><li>Real-time messaging: Send instant messages to team members and clients. It has options for direct messages, group chats, and dedicated channels for specific topics.</li><li>Task management: Create a new task from a conversation.</li><li>ChatGPT integration: Summarize the conversation, change the tone of voice, and request recommendations for response.</li><li>Customizable notifications: Tailor notifications to your preferences.</li></ul></div>",
    "Color": "Color",
    "Are you sure to delete this field? You may lose the data.": "Are you sure you want to delete this field? You may lose the data.",
    "Add field": "Add field",
    "Add section": "Add section",
    "multiline": "multiline",
    "Import": "Import",
    "Import data": "Import data",
    "Automate data collection with Smart Accounts": "Automate data collection with Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automate your billing process by connecting Xero to Uku.</p> <div class='body-2'><p>Benefits of the Xero integration:</p><ul><li>Import all your clients from Xero to Uku with just a couple of clicks</li><li>Import product codes and classificators to Uku</li><li>Create invoices automatically in Uku and send them to Xero</li></ul></div>",
    "Import clients from {0}": "Import clients from {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Before importing clients, you need to authorize with Xero and select the Company.",
    "Authorize Xero to start import": "Authorize Xero to start import",
    "Failed to import clients": "Failed to import clients",
    "Failed to connect to WS": "Failed to connect to WS",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "Email signatures",
    "Everyone": "Everyone",
    "Access": "Access",
    "Creator": "Creator",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Email addresses",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku securely integrates with your email to help you manage and automate communication",
    "Use {0} address": "Use {0} address",
    "connect your email address": "connect your email address",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Connect with Microsoft Exchange or other email server(SMTP)",
    "Email integration reconnected": "Email integration reconnected",
    "Are you sure you want to delete this email integration?": "Are you sure you want to delete this email integration?",
    "Email templates": "Email templates",
    "Add email template": "Add email template",
    "Are you sure you want to save this template? Some tasks will be affected": "Are you sure you want to save this template? Some tasks will be affected",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "<p class='title'>Automate your billing process by connecting e-conomic to Uku</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku with just a couple of clicks</li><li>import products and classificators from e-conomic to Uku</li><li>create invoices automatically in Uku and send them to e-conomic</li></ul></p></div>",
    "Default layout": "Default layout",
    "Change agreement ID": "Change agreement ID",
    "Failed to connect to server": "Failed to connect to server",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "<div class='body-2'><p>Import the following data from e-conomic to Uku:<ul><li>clients,</li><li>products,</li><li>units,</li><li>layout templates.</li></ul></p><p>In the next step you’ll be able to select the clients you want to add or update</p></div>.",
    "Connect e-conomic": "Connect e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Before importing clients, you need to connect Uku and e-conomic software. To do this, create e-conomic agreement and enter the agreement ID here.",
    "Step {0}": "Step {0}",
    "Get agreement ID": "Get agreement ID",
    "Insert agreement ID": "Insert agreement ID",
    "Connect": "Connect",
    "quickbooks_app_overview_text": "<p class='title'>Automate your billing process by connecting QuickBooks Online to Uku.</p> <div class='body-2'><p>Benefits of the QuickBooks integration:</p><ul><li>Import all your clients from QuickBooks to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with QuickBooks.": "Before importing clients, you need to connect with QuickBooks.",
    "Connected to QuickBooks": "Connected to QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automate your billing process by connecting Fortnox to Uku.</p> <div class='body-2'><p>Benefits of the Fortnox integration:</p><ul><li>Import all your clients from Fortnox to Uku with just a couple of clicks.</li><li>Import products and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with Fortnox.": "Before importing clients, you need to connect with Fortnox.",
    "Connect to Fortnox": "Connect to Fortnox",
    "Connected to Fortnox": "Connected to Fortnox",
    "Delete template": "Delete template",
    "Public": "Public",
    "Workflow templates": "Workflow templates",
    "No workflow templates yet": "No workflow templates yet",
    "Modified": "Modified",
    "Uku workflow templates": "Uku workflow templates",
    "Are you sure you wish to delete this workflow?": "Are you sure you want to delete this workflow?",
    "Project fields": "Project fields",
    "Progress step": "Progress step",
    "Rename project": "Rename project",
    "Project statuses": "Project statuses",
    "You can use the statuses to restrict the workflow.": "You can use the statuses to restrict the workflow.",
    "Project phases": "Project phases",
    "Make your progress beautiful.": "Make your progress beautiful.",
    "Permissions": "Permissions",
    "Users can manage workflow templates": "Users can manage workflow templates",
    "project_app_overview_text": "Handle projects from initiation to completion with ease.",
    "project_app_overview_description": "<div class='body-2'><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customizable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualize progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customization: </b>Tailor projects to your organization’s needs with customizable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Configure summary task",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku will generate a task with the following title and topic on the last day of the month.",
    "Task title": "Task title",
    "Recurrence": "Recurrence",
    "First import start date": "First import start date",
    "Count changes from previous periods": "Count changes from previous periods",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.",
    "Automatically finish summary tasks": "Automatically finish summary tasks",
    "If enabled, summary tasks will be created as finished.": "If enabled, summary tasks will be created as finished.",
    "Configure data fields": "Configure data fields",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Select the corresponding Uku field for each imported field. Same fields will be summarized. By leaving a field blank it will be ignored.",
    "New custom field": "New custom field",
    "Show more": "Show more",
    "Every month": "Every month",
    "Last work day of the month": "Last work day of the month",
    "Last day of the month": "Last day of the month",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Day {0} of next month",
    "Settings saved": "Settings saved",
    "Uku will let you know when it is ready.": "Uku will let you know when it’s ready",
    "Reload data": "Import data now",
    "months": "months",
    "This will overwrite existing summary tasks new values.": "This will overwrite existing summary tasks new values.",
    "Overwrite": "Overwrite",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.",
    "Connect Trigon": "Connect Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.",
    "Insert email and password": "Insert email and password",
    "Automate your anti money laundering process": "Automate your anti-money laundering process",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "You are about to activate the anti-money laundering process. During this, new additional fields will be added to your client's data and also the system will begin reminding you to update them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Status</il><li>Document No.</il><li>Document valid until</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "You are about to activate the anti-money laundering process. During this, new additional fields will be added to your client's data and also the system will begin reminding you to update them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>",
    "Do not change client custom fields created by Uku": "Works with client custom field created by Uku",
    "day(s) before": "day(s) before",
    "Task name": "Task name",
    "Assigned": "Assigned",
    "Note": "Note",
    "Manual run": "Manual run",
    "Create a task when the document expires": "Create a task when the document expires",
    "Create a task when the risk profile must be updated": "Create a task when the risk profile must be updated",
    "Flextime period": "Flextime period",
    "Confirmation period": "Confirmation period",
    "Weekly": "Weekly",
    "Add agreement": "Add agreement",
    "flextime_app_overview_text": "<p class='title'>Get an overview of your team's working hours, overtime, and vacation balance.</p> <div class='body-2'><p></p><p>Flextime benefits:</p><ul><li>Convenient overview of work and overtime</li><li>Accessible vacation management and balance overview</li><li>Easy data export for your accountant</li></ul></div>",
    "supplier_app_overview_text": "Manage your partners and vendors.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organizations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Supplier type",
    "Parent type": "Parent type",
    "Edit supplier type": "Edit supplier type",
    "New supplier type": "New supplier type",
    "Are you sure you wish to delete this supplier type?": "Are you sure you want to delete this supplier type?",
    "Types": "Types",
    "Supplier types": "Supplier types",
    "No supplier types yet": "No supplier types yet",
    "tripletex_app_overview_text": "<p class='title'>Automate your billing process by connecting Tripletex to Uku.</p> <div class='body-2'><p>Benefits of the Tripletex integration:</p><ul><li>Import all your clients from Tripletex to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.",
    "Connect Tripletex": "Connect Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.",
    "Get employee token": "Get employee token",
    "Insert employee token": "Insert employee token",
    "Install": "Install",
    "Open Chrome browser to install": "Open Chrome browser to install",
    "Works with your online accounting software.": "Works with your online accounting software.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.",
    "merit_aktiva_app_overview_text_pl": "<p class='title'>Importuj klientów i ilość pracy, aby otrzymać jeden raport z danymi dotyczącymi wykonanej pracy dla wszystkich klientów.</p><div class='body-2'><p>Spraw, aby zbieranie danych było szybkie i dokładne dzięki integracji 360 Księgowość i Uku. Uku automatycznie importuje faktury sprzedaży i zakupu, dokumenty, wpisy, itd. dla każdego klienta i zbiera nakład pracy oraz wpisy czasowe w jednym, interaktywnym raporcie. Koniec z przełączaniem się między klientami w oprogramowaniu księgowym w celu uzyskania informacji o przetworzonych dokumentach, aby utworzyć faktury lub monitorować wydajność klienta. W porównaniu do 360 Księgowość, Uku importuje rzeczywistą liczbę wpisów z ostatniego miesiąca, biorąc pod uwagę wszystkie zmiany, które zostały wprowadzone do poprzednich okresów. Oznacza to, że nie musisz zapamiętywać ani zapisywać żadnych zmian, które wprowadziłeś - Uku ma wszystkie te informacje i Ty też będziesz je mieć. Zautomatyzowane zbieranie danych oszczędza Twój czas i eliminuje błąd ludzki.</p><p>Integracja Uku i 360 Księgowość pomaga Ci:</p><p><ul><li>Szybko i dokładnie zbierać dane - ilość pracy jest automatycznie importowana do Uku z 360 Księgowość</li><li>Analizować obciążenie pracą i czas dzięki dostępowi do pełnego podsumowania wykonanej pracy i czasu spędzonego na klientach</li><li>Zautomatyzować tworzenie zestawień miesięcznych</li><li>Uzyskać przegląd rzeczywistego obciążenia pracą w każdym miesiącu</li></ul></p><p>Dzięki integracji Uku - 360 Księgowość możesz zaimportować:</p><p><ul><li>Dokumenty</li><li>Wpisy</li><li>Faktury przedaży</li><li>Faktury kupna</li><li>Operacje bankowe</li><li>Operacje gotówkowe</li><li>Wpisy VAT</li><li>Zapisy zasobów</li><li>Itd.</li></ul></p></div>",
    "merit_aktiva_app_overview_text": "<p class='title'>Import clients and the volume of work to get one report with work done data for all your clients.</p><div class='body-2'><p>Make your data collection fast and accurate with Merit Aktiva and Uku integration. Uku automatically imports sales and purchase invoices, documents, entries, etc. for each client and performs volume of work and time-entries in one interactive report. No more switching between clients in your accounting software to get information about documents processed to create invoices or monitor client performance. Compared to Merit, Uku imports the actual amount of entries for last month, taking into account all changes that were inserted into previous periods. Meaning that you don't have to remember or write down any changes you have made - Uku has all that information and so will you. Automated data collection saves you time and eliminates human errors.</p><p>Uku and Merit Aktiva integration helps you to:</p><p><ul><li>Quickly and accurately gather data - volume of work is imported to Uku from Merit automatically</li><li>Analyze workload and time by having a full overview of work done and time spent on clients</li><li>Automate the creation of monthly summaries </li><li>Get an overview of the actual workload each month</li></ul></p><p>With Uku - Merit integration you can import the amount of:</p><p><ul><li>Documents</li><li>Entries</li><li>Sales invoices</li><li>Purchase invoices</li><li>Bank entries</li><li>Cash entries</li><li>VAT entries</li><li>Stock entries</li><li>Etc.</li></ul></p></div>",
    "Import clients": "Import clients/contacts",
    "documents_app_overview_text": "<div class='body-2'><p>Save all your files directly to your company's document repository. Keep a backup in Uku.</p><p>Key features:</p><ul><li><b>Folder structure:</b>Define the main folder where Uku should save the files. You can define specific folders per client or have Uku generate the folders per client / per year / per month for you!</li><li><b>Which files to save:</b>Have Uku save all files uploaded or created in Uku to your document repository or only the ones uploaded by the clients. You have full control over what is stored in the repository and what not.</li><li><b>Open files for review:</b>Uploaded files are opened directly in your document repository. No need to download the file to work with it.</li><li><b> Backup:</b>If wished you may back up all your files in Uku!</li></li></ul><p></p><p>Supported file management systems:</p><div class='d-flex align-center'><img style='width: 45px;' src='/static/img/google-drive.svg'> <b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>Google Drive</b><img style='width: 55px;' src='/static/img/onedrive.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>OneDrive</b><img style='width: 50px;' src='/static/img/sharepoint.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>SharePoint</b></div><p style='padding-bottom: 30px'></p></div>",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "Setup your SharePoint connection": "Setup your SharePoint connection",
    "Site URL": "Site URL",
    "Client ID": "Client ID",
    "Client secret": "Client secret",
    "Connection successful!": "Connection successful!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "When disconnecting the service Uku will no longer be able to access the documents.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Refresh",
    "Be aware of the issues before they become problems": "Be aware of the issues before they become problems",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitization:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalized experience.</li><li><b>Customizable Branding:</b> Add logos, icons, colors and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Branding",
    "Subdomain": "Subdomain",
    "Default language": "Default language",
    "Client portal URL in other languages": "Client portal URL in other languages",
    "Copy URL": "Copy URL",
    "Trademark": "Trademark",
    "Default signature": "Default signature",
    "Trademark text color": "Trademark text color",
    "Choose color": "Choose color",
    "Brand background color": "Brand background color",
    "Logo": "Logo",
    "Max. dimensions 180 x 60 px": "Max. dimensions 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Delete icon",
    "Upload icon file": "Upload icon file",
    "Recommended size 260 x 260 px": "Recommended size 260 x 260 px",
    "Company description": "Company description",
    "Displayed on the login page.": "Displayed on the login page.",
    "Describe here what services you offer and how you help your clients.": "Describe here what services you offer and how you help your clients.",
    "Welcome video": "Welcome video",
    "Displayed on the login page when your client contact enters for the first time": "Displayed on the login page when your client contact enters for the first time.",
    "Use Uku video": "Use Uku video",
    "View": "View",
    "Use other video": "Use other video",
    "Youtube or Vimeo video URL": "Youtube or Vimeo video URL",
    "Show file upload box for client tasks": "Show file upload box for client tasks",
    "Invalid data": "Invalid data",
    "Client portal preview": "Client portal preview",
    "Client portal URL for {0} copied to clipboard": "Client portal URL for {0} copied to clipboard",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with FreeAgent.": "Before importing clients, you need to connect with FreeAgent.",
    "Connect to FreeAgent": "Connect to FreeAgent",
    "Connected to FreeAgent": "Connected to FreeAgent",
    "freeagent_app_overview_text": "<p class=‘title’>Automate your company setup by importing clients from Freeagent!</p><div class=‘body-2’><p>Import all your clients from Freeagent to Uku with just a couple of clicks.</p></div>",
    "Add recurring task": "Add recurring task",
    "Reminder tasks updated": "Reminder tasks updated",
    "Create recurring tasks for Companies House clients.": "Create recurring tasks for Companies House clients.",
    "companies_house_app_overview_text": "<p class='title'>Never forget to file your clients' annual statements with Companies House.</p> <div class='body-2'><p>Activating Companies House in Uku will:</p><p><ul><li>Set up Companies House client fields for your clients based in the United Kingdom.</li><li>Automatically keep Companies House data up-to-date for these clients.</li></ul></p><p>Set up reminders to file your clients' statements and tax returns:</p><p><ul><li>Set up yearly recurring tasks for different annual statements.</li><li>Reminder tasks will be created separately for every client based on that client's due dates.</li><li>Customize when these tasks should appear and what should be done.</li></ul></p></div>",
    "buttons": "buttons",
    "Show to me": "Show me",
    "magic_button_app_overview_text": "<p class='title'>With one click, add a new task and start the timer.</p> <div class='body-2'><p>Magic buttons allow you to insert urgent work (phone call, email) conveniently.</p><p>Insert all tasks immediately to Uku</p><p>Magic buttons allow you to add urgent tasks (phone call, email) to Uku conveniently. That ensures tasks are inserted into Uku properly.</p><p>Magic buttons:</p><ul><li>Insert a new task and start the timer with one click (move to + button in the header).</li><li>Customize magic buttons according to your needs.</li><li>Modify the client or other information afterward.</li><li>Continue with the previous task that you can quickly access from the magic buttons list.</li></ul></div>",
    "Buttons": "Buttons",
    "Member rights": "Member rights",
    "Allow managers to view and create their client contracts and invoices": "Allow managers to view and create their client contracts and invoices",
    "Allow members to view and create their client invoices": "Allow members to view and create their client invoices",
    "Allow members to view their client invoices": "Allow members to view their client invoices",
    "Allow only owners to add and update products": "Allow only owners to add and update products",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Allow members to confirm their client invoice rows",
    "Send PDF invoice": "Send PDF invoice",
    "Send invoice copy": "Send invoice copy",
    "Default rounding": "Default rounding",
    "Round all times up to x": "Round all times up to x",
    "Time rounding increment": "Time rounding increment",
    "Apply time rounding to": "Apply time rounding to",
    "Default configuration": "Default configuration",
    "Invoice date": "Invoice date",
    "Invoice entry date": "Invoice entry date",
    "Bill tracked time by": "Bill tracked time by",
    "Bill task field by": "Bill task field by",
    "Create one invoice merging invoices from the same period": "Create one invoice merging invoices from the same period",
    "Invoices from the same period": "Invoices from the same period",
    "Hide zero sum lines": "Hide zero sum lines",
    "By default, time entry is billable": "By default, time entry is billable",
    "Invoice number": "Invoice number",
    "Prefix": "Prefix",
    "Suffix": "Suffix",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Billing settings saved",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimizing human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Product",
    "Contract templates": "Contract templates",
    "Invoice templates": "Invoice templates",
    "Tools": "Tools",
    "Replace tax": "Replace tax",
    "Old tax": "Old tax",
    "New tax": "New tax",
    "Find tax": "Find tax",
    "Replace VAT in products": "Replace VAT of products",
    "Replace VAT in master contracts": "Replace VAT in master contracts",
    "Replace VAT in client contracts & draft invoices": "Replace VAT in client contracts & draft invoices",
    "Replace VAT values": "Replace VAT values",
    "This action cannot be undone": "This action cannot be undone",
    "Replace": "Replace",
    "Result": "Result",
    "PDF templates": "PDF templates",
    "E-mail templates": "Email templates",
    "Edit PDF template": "Edit PDF template",
    "Import classificators": "Import classificators",
    "products": "products",
    "product": "product",
    "Product / service": "Product / service",
    "Calculate": "Calculate",
    "Article": "Article",
    "Resource": "Resource",
    "Cost center": "Cost center",
    "Taxes": "Taxes",
    "Code": "Code",
    "Source": "Source",
    "Articles": "Articles",
    "Resources": "Resources",
    "Cost centers": "Cost centers",
    "Units": "Units",
    "Unit": "Unit",
    "Bank accounts": "Bank accounts",
    "Bank account": "Bank account",
    "Bank name": "Bank name",
    "SWIFT code": "SWIFT code",
    "VAT number": "VAT number",
    "Do you wish to import only new data or also overwrite existing?": "Do you wish to import only new data or also overwrite existing?",
    "Only new": "Only new",
    "New items will be added. Existing ones will remain unchanged by import.": "New items will be added. Existing ones will remain unchanged by import.",
    "Import everything": "Import everything",
    "Connect accounting service": "Connect accounting service",
    "Service": "Service",
    "API ID": "API ID",
    "API key": "API key",
    "Company Account Id": "Company Account ID",
    "Api secret": "API secret",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Test",
    "Lock time entries": "Lock time entries",
    "Owner rights": "Owner rights",
    "Disable company settings edit for all members": "Disable editing company settings for members",
    "Disable personal clients for members": "Disable personal clients for members",
    "Show member birthdays": "Show member birthdays",
    "Show contact birthdays": "Show contact birthdays",
    "Weekly @ Sun {0}": "Weekly @ Sun {0}",
    "Monthly @ last day of month": "Monthly @ last day of month",
    "Company event list": "Company event list",
    "How long?": "How long?",
    "Invoice no.": "Invoice No.",
    "Login options": "Login options",
    "Tenant ID (optional)": "Tenant ID (optional)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect",
    "How to find ID’s?": "How to find tenant ID-s?",
    "Microsoft connected": "Microsoft connected",
    "Google connected": "Google connected",
    "Edit company": "Edit company",
    "Timezone": "Time zone",
    "Invoice email": "Invoice email",
    "Subscription plan": "Subscription plan",
    "Payment failed": "Payment failed",
    "Retry payment": "Retry payment",
    "Next payment": "Next payment",
    "Update payment method": "Update payment method",
    "Plan": "Plan",
    "Choose a plan": "Choose a plan",
    "Change plan": "Edit plan",
    "{0}-day free trial until {1}": "{0}-day free trial until {1}",
    "monthly": "monthly",
    "yearly": "yearly",
    "{0} member": "{0} member",
    "{0} members": "{0} members",
    "{0} plan": "{0} plan",
    "Cancelled (valid until {0})": "Cancelled (valid until {0})",
    "Your trial expired on {0}": "Your trial expired on {0}",
    "Your subscription expired on {0}": "Your subscription expired on {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan",
    "Save {0} by paying for a year!": "Save {0} by paying for a year!",
    "Choose plan": "Choose plan",
    "Pay annually": "Pay annually",
    "Instructions sent!": "Instructions sent!",
    "Instructions for resetting your password have been sent to": "Instructions for resetting your password have been sent to",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "You’ll receive this email within 5 minutes. Be sure to check your spam folder too.",
    "Back to login page": "Back to login page",
    "Get new password": "Get new password",
    "Pick a password": "Create a password",
    "Use minimum 8 characters with letters & numbers": "Minimum 8 characters using both letters & numbers",
    "Create your Uku Account": "Create your Uku Account",
    "Connect your Xero Account": "Connect your Xero Account",
    "Phone": "Phone",
    "I agree to the": "I agree to the",
    "Terms of Service": "Terms of Service",
    "Next": "Next",
    "Having trouble?": "Having trouble?",
    "We can help": "We can help",
    "Log in instead": "Log in instead",
    "You are invited to join": "You are invited to join",
    "Accept invitation": "Accept invite",
    "Check your email": "Check your email",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "I sent you an email with a link to activate your account. This is important to ensure the security of your account.",
    "Go to": "Go to",
    "Need a new password?": "Need to reset your password?",
    "Enter your e-mail address and we will send you directions for changing your password": "Enter your e-mail address and we will send you directions for changing your password",
    "Send me instructions": "Send me instructions",
    "Never mind, go back": "Never mind, go back",
    "No login options enabled. Please contact the company owner": "No login options enabled. Please contact the company owner",
    "Log in to Uku": "Log in to Uku",
    "Forgot password?": "Forgot password?",
    "Don't have account?": "Don't have an account?",
    "Create account": "Create account",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!",
    "Total items:": "Total items:",
    "Add new": "Add new",
    "Amount": "Amount",
    "Account created range": "Account created range",
    "Usage limit": "Usage limit",
    "Valid until": "Valid until",
    "Edit help link": "Edit help link",
    "New help link": "New help link",
    "Name key": "Name key",
    "Country code": "Country code",
    "Period (months)": "Period (months)",
    "Account created from": "Account created from",
    "Account created until": "Account created until",
    "Used count": "Used count",
    "Free days": "Free days",
    "Sum": "Sum",
    "Create voucher": "Create voucher",
    "Edit voucher": "Edit voucher",
    "Are you sure to delete this voucher?": "Are you sure you want to delete this voucher?",
    "row | rows": "row | rows",
    "Add event": "Add event",
    "Are you sure you wish to delete this event?": "Are you sure you want to delete this event?",
    "event | events": "event | events",
    "Security object id": "Security object id",
    "Direct rights": "Direct rights",
    "Computed rights": "Computed rights",
    "Add link": "Add link",
    "Are you sure you wish to delete this entry?": "Are you sure you want to delete this entry?",
    "link | links": "link | links",
    "Event type": "Event type",
    "Date from": "Date from",
    "Date until": "Date until",
    "Shortened by h": "Shortened by h",
    "Category": "Category",
    "demo | demos": "demo | demos",
    "Created at": "Created at",
    "Invited by": "Invited by",
    "referral | referrals": "referral | referrals",
    "Companies": "Companies",
    "Leads": "Leads",
    "Demos": "Demos",
    "Vouchers": "Vouchers",
    "KPI": "KPI",
    "Referrals": "Referrals",
    "Activity log": "Activity log",
    "Notifications": "Notifications",
    "Me": "Me",
    "Important notifications will appear here.": "Important notifications will appear here.",
    "Back": "Back",
    "Return to UKU": "Return to Uku",
    "Choose plan for {0}": "Choose plan for {0}",
    "First payment will be made after the end of the trial period.": "First payment will be made after the end of the trial period.",
    "Members and subscription can always be changed.": "Members count and subscription plan can always be changed.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Billing period",
    "Compare features": "Compare features",
    "Cancel uku subscription": "Cancel Uku subscription",
    "{0} discount": "{0} discount",
    "You have currently<br />{0} active member": "You have currently<br />{0} active member",
    "You have currently<br />{0} active members": "You have currently<br />{0} active members",
    "Select yearly plan": "Select yearly plan",
    "Select monthly plan": "Select monthly plan",
    "Attention!": "Attention!",
    "Plan change request": "Plan change request",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "If you want to use Uku for free then deactivate your account and continue with {0} plan",
    "per member/month (billed yearly)": "per member/month (billed yearly)",
    "or {0} per member/month (monthly)": "or {0} per member/month (billed monthly)",
    "Everything in {0}, plus:": "Everything in {0}, plus:",
    "Compare plans, feature-by-feature": "Compare plans, feature-by-feature",
    "Deactivate account": "Deactivate account",
    "Are you sure to deactivate {0} account?": "Are you sure you want to deactivate {0} account?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "If you choose to continue with Solo plan your company account will be deactivated. Data that is related to this company will be removed.",
    "Deactivate": "Deactivate",
    "Teamwork": "Teamwork",
    "Unlimited clients + import": "Unlimited clients + import",
    "Access management": "Access management",
    "Custom fields": "Custom fields",
    "Live chat support": "Live chat support",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Client Portal",
    "New!": "New!",
    "Custom integrations": "Custom integrations",
    "Assisted clients import": "Assisted clients import",
    "Tailor-made team workshop": "Tailor-made team workshop",
    "Early access to features": "Early access to features",
    "Pay by invoice": "Pay by invoice",
    "Dedicated account manager": "Dedicated account manager",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Hi! Your trial with {0} is over. Please choose a subscription plan to continue work",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Hi! You need to upgrade {0} subscription plan to use that feature",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "VAT": "VAT",
    "This is subscription period amount.": "This is subscription period amount.",
    "You save yearly {0}": "You save yearly {0}",
    "Add voucher": "Add voucher",
    "Existing credit": "Existing credit",
    "Current payment": "Current payment",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.",
    "Confirm subscription {0}": "Confirm subscription {0}",
    "Your subscription will renew on": "Your subscription’s next payment date is on",
    "Thank you for believing in us!": "Thank you for believing in us!",
    "Uku team": "Uku team",
    "Voucher {1} (-{0}%)": "Voucher {1} (-{0}%)",
    "Voucher {0}": "Voucher {0}",
    "New plan": "New plan",
    "Changed plan": "Changed plan",
    "Add {0} member": "Add {0} member",
    "Add {0} members": "Add {0} members",
    "Remove {0} member": "Remove {0} member",
    "Remove {0} members": "Remove {0} members",
    "No changes to plan": "No changes to plan",
    "Discount -{0}% with Yearly subscription": "Discount -{0}% with yearly subscription",
    "Yearly discounted price (-{0}%)": "Yearly discounted price (-{0}%)",
    "Subscription updated": "Subscription updated",
    "Please wait": "Please wait",
    "Your payment failed": "Your payment failed",
    "Please check that you entered the data correctly or use another card": "Please check that you entered the data correctly or use another card",
    "Try again": "Try again",
    "Pay": "Pay",
    "Payment": "Payment",
    "Payment method updated": "Payment method updated",
    "Edit member": "Edit member",
    "First name": "First name",
    "Last name": "Last name",
    "External ID": "External ID",
    "Select groups": "Select groups",
    "Administrator": "Administrator",
    "Activate member": "Activate member",
    "Deactivate member": "Deactivate member",
    "Paid member": "Paid member",
    "Send an invitation": "Send an invite",
    "Limited": "Limited",
    "No invite, no access": "No invite, no access",
    "Free until activated": "Free until activated",
    "No access, no charge": "No access, no charge",
    "Hidden member": "Hidden member",
    "Edit members": "Edit members",
    "Select user": "Select user",
    "Member will be assigned to every selected client": "Member will be assigned to every selected client",
    "Member will be removed from all selected clients": "Member will be removed from all selected clients",
    "Assign user": "Assign user",
    "Set as primary user": "Set as primary member",
    "Added as a default user when adding a task plan": "Added as a default user when adding a task plan",
    "Remove from new tasks": "Remove from new tasks",
    "Remove from plan tasks": "Remove from plan tasks",
    "Remove": "Remove",
    "Admin": "Admin",
    "Remove user": "Remove user",
    "Assign to incomplete tasks": "Assign to incomplete tasks",
    "Reassign incomplete tasks": "Reassign incomplete tasks",
    "Assign to plan tasks": "Assign to plan tasks",
    "Reassign plan tasks": "Reassign plan tasks",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Owner will be assigned to tasks if there is no new user assigned in place of the removed user.",
    "Run integration": "Run integration",
    "Run": "Run",
    "Integration configuration": "Integration configuration",
    "Read the manual": "Read the manual",
    "Api key": "API key",
    "Are you sure to delete this integration info?": "Are you sure you want to delete this integration info?",
    "Edit Contracts": "Edit Contracts",
    "Replace following contracts": "Replace following contracts",
    "Append services to following contracts": "Append services to following contracts",
    "Choose template": "Choose templates",
    "Append only": "Append only",
    "with template": "with template",
    "All existing contracts": "All existing contracts",
    "All quarterly contracts": "All quarterly contracts",
    "All monthly contracts": "All monthly contracts",
    "All yearly contracts": "All yearly contracts",
    "Next invoice number": "Next invoice number",
    "Number is too big, it cannot exceed 15 digits": "Number is too big, it cannot exceed 15 digits",
    "Replace topic": "Replace topic",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "All tasks and plans including the current topic will be replaced with the new selected topic.",
    "Topics replaced": "Topics replaced",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?",
    "Name of topic": "Name of topic",
    "New time entries will be marked as non-billable": "New time entries will be marked as non-billable",
    "Change topic": "Edit topic",
    "Add new topic": "Add new topic",
    "This topic is in use. Do you wish to archive it?": "This topic is in use. Do you want to archive it?",
    "Are you sure that you want to delete this topic?": "Are you sure you want to delete this topic?",
    "These items will be deleted permanently": "These items will be deleted permanently",
    "Are you sure that you want to delete this client group?": "Are you sure that you want to delete this client group?",
    "This client group is in use. Do you wish to archive it?": "This client group is in use. Do you wish to archive it?",
    "Edit client group": "Edit client group",
    "New client group": "New client group",
    "Price": "Price",
    "Quantity": "Quantity",
    "Unit will be translated to client language": "Unit will be translated to client language",
    "Pick date & time": "Pick date & time",
    "Share equally": "Share equally",
    "Change existing": "Change existing",
    "Choose bookmark": "Choose bookmark",
    "New title": "New title",
    "Set as my default view": "Set as my default view",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Actions",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Do you wish to update related contracts and invoices?",
    "Update contract templates, active contracts and open invoices.": "Update contract templates, active contracts and open invoices.",
    "The following fields will be updated": "The following fields will be updated",
    "Custom Value": "Custom Value",
    "This product is in use. Do you wish to archive it?": "This product is in use. Do you want to archive it?",
    "Are you sure that you want to delete this product?": "Are you sure that you want to delete this product?",
    "Customize for client": "Customize for client",
    "Customize for template": "Customize for template",
    "Open product template": "Open product template",
    "Create product template": "Create product template",
    "Master template": "Master template",
    "Client product": "Client product",
    "Client product / service": "Client product / service",
    "New client product": "New client product",
    "Template product": "Template product",
    "Template product / service": "Template product / service",
    "New template product": "New template product",
    "Edit translations": "Edit translations",
    "Billable topics": "Billable topics",
    "Billable time": "Billable time",
    "Minimum quantity": "Minimum quantity",
    "Minimum time": "Minimum time",
    "Integration parameters": "Integration parameters",
    "Empty values will use product default": "Empty values will use product default",
    "Pricing": "Pricing",
    "DC %": "DC %",
    "Sum all matching rows": "Sum all matching rows",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "When enabled, product's price on an invoice is a cumulative sum of all matching rows. By default, product's price is that of the highest matching row.",
    "Prices since": "Prices since",
    "Add price": "Add price",
    "Add pricing period": "Add pricing period",
    "Update contracts": "Update contracts",
    "(Without topic)": "(Without topic)",
    "Fixed price": "Fixed price",
    "Product": "Product",
    "Event created": "Event created",
    "Project created": "Project created",
    "Event deleted": "Event deleted",
    "Project deleted": "Project deleted",
    "Workflow added": "Workflow added",
    "Workflow removed": "Workflow removed",
    "Workflow updated": "Workflow updated",
    "Event cancelled": "Event cancelled",
    "Project cancelled": "Project cancelled",
    "Event reactivated": "Event reactivated",
    "Project reactivated": "Project reactivated",
    "Event archived": "Event archived",
    "Project archived": "Project archived",
    "Event unarchived": "Event unarchived",
    "Project unarchived": "Project unarchived",
    "Event changed": "Event changed",
    "Project changed": "Project changed",
    "Event status changed: {0}": "Event status changed: {0}",
    "Project status changed: {0}": "Project status changed: {0}",
    "Event status changed": "Event status changed",
    "Project status changed": "Project status changed",
    "Task created": "Task created",
    "Task changed": "Task changed",
    "Task finished": "Task finished",
    "Task not finished": "Task not finished",
    "Task deleted": "Task deleted",
    "Add project": "Add project",
    "Hide filters": "Hide filters",
    "Show filters": "Show filters",
    "Cancel event": "Cancel event",
    "Cancel project": "Cancel project",
    "Manage event fields": "Manage event fields",
    "Manage project fields": "Manage project fields",
    "New event": "New event",
    "New project": "New project",
    "{0} (Copy)": "{0} (Copy)",
    "Are you sure you wish to delete this project?": "Are you sure you want to delete this project?",
    "Are you sure to archive this event?": "Are you sure to archive this event?",
    "Are you sure to archive this project?": "Are you sure you want to archive this project?",
    "Are you sure to cancel this event?": "Are you sure to cancel this event?",
    "Are you sure to cancel this project?": "Are you sure you want to cancel this project?",
    "Communication": "Communication",
    "Log": "Log",
    "Create event workflow": "Create event workflow",
    "Create project workflow": "Create project workflow",
    "Use workflow templates to set up tasks effectively or": "Use workflow templates to set up tasks effectively or",
    "Add tasks manually": "Add task manually",
    "Save bookmark": "Save bookmark",
    "Remove filters": "Remove filters",
    "Filter": "Filter",
    "Show multiselect": "Show multiselect",
    "To do today": "To do today",
    "This and next month": "This and next month",
    "Last 3 months": "Last 3 months",
    "Next 3 months": "Next 3 months",
    "Starts": "Starts",
    "To do": "To do",
    "today": "today",
    "tomorrow": "tomorrow",
    "yesterday": "yesterday",
    "Previous week": "Previous week",
    "Group similar tasks": "Group similar tasks",
    "Group by client": "Group by client",
    "Group by date": "Group by date",
    "Group by topic": "Group by topic",
    "Are you sure to remove google?": "Are you sure you want to remove your Google connection?",
    "Google log in": "Google login",
    "Microsoft log in": "Microsoft login",
    "Are you sure to remove microsoft?": "Are you sure you want to remove your Microsoft connection?",
    "Are you want to disconnect Xero?": "Are you want to disconnect Xero?",
    "Reset password": "Reset password",
    "Your details": "My details",
    "City": "City",
    "Regional format": "Regional format",
    "Default company": "Default company",
    "Lock time entries notification": "Time entries about to lock",
    "Notify by": "Notify by",
    "Delete my account": "Delete my account",
    "Attention": "Attention",
    "Are you sure that you want to delete your account?": "Are you sure you want to delete your account?",
    "Notification": "Notification",
    "Notification & email": "Notification & email",
    "Vacations / absence": "Vacations / absences",
    "Edit balance": "Edit balance",
    "View history": "View history",
    "Request": "Request",
    "How long": "How long",
    "Requested": "Requested",
    "Approved": "Approved",
    "Rejected": "Rejected",
    "In review": "In review",
    "Change": "Edit",
    "Agreements": "Agreements",
    "New agreement": "New agreement",
    "Change agreement": "Change agreement",
    "Stop demo": "Stop demo",
    "Show": "Show",
    "Don't show": "Don't show",
    "Don't send": "Don't send",
    "Email workdays at 7 AM": "Email workdays at 7 AM",
    "Email at 3 PM": "Email at 3 PM",
    "Email at once": "Email at once",
    "Email Sundays at 11 PM": "Email Sundays at 11 PM",
    "First day of the month": "First day of the month",
    "to email": "Email at once",
    "E-mail at once": "Email at once",
    "System": "System",
    "Person": "Person",
    "Picture": "Picture",
    "Time zone": "Time zone",
    "Calendar settings": "Calendar settings",
    "Public holidays": "Public holidays",
    "Tax deadlines": "Tax deadlines",
    "News": "News",
    "External services": "External services",
    "Agreement": "Agreement",
    "Active agreement": "Active agreement",
    "Weekly hours": "Weekly hours",
    "Edit supplier": "Edit supplier",
    "New supplier": "New supplier",
    "Are you sure you wish to delete this supplier?": "Are you sure you want to delete this supplier?",
    "Add supplier": "Add supplier",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Supplier types are not defined. Please go to the suppliers app settings to add.",
    "No members yet": "No members yet",
    "Edit group": "Edit group",
    "Add group": "Add group",
    "Are you sure to delete this user group?": "Are you sure you want to delete this user group?",
    "Get set up to work with team": "Get set up to work with a team",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team’s workflow and lead a more profitable business.",
    "Create company account": "Create company account",
    "By creating a company account you activate Uku free subscription for {0} days.": "By creating a company account you activate your Uku free subscription for {0} days.",
    "You have invited {0}/{1} members": "You have {0}/{1} active members",
    "Upgrade": "Upgrade",
    "View profile": "View profile",
    "To add members to your team, you'll need to create a company account": "To add members to your team, you’ll need to create a company account",
    "Export": "Export",
    "Re-invite sent": "Invite sent",
    "View report": "View report",
    "Member {0} will be deactivated.": "Member {0} will be deactivated.",
    "Please select new member who will replace {0}.": "Please select new member who will replace {0}.",
    "Select new member": "Select new member",
    "NB! Deactivation process cannot be reversed": "NB! Deactivation process cannot be reversed",
    "Magic button settings": "Magic button settings",
    "Create only one task per month": "Create only one task per month",
    "Current month's tasks": "Current month's tasks",
    "extra work": "extra work",
    "Without topic": "Without topic",
    "Week": "Week",
    "Previous month": "Previous month",
    "task | tasks": "task | tasks",
    "Assign to": "Assign to",
    "Mark as done": "Mark as done",
    "Last": "Last",
    "Snooze": "Snooze",
    "1 dependency": "1 dependency",
    "{0} dependencies": "{0} dependencies",
    "Client request": "Client request",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Add comment",
    "Internal comment": "Internal comment",
    "Portal message": "Portal message",
    "Public message means that clients can read it and the client portal will notify them by email": "Portal messages are visible to client and responsible client contact will be notified of them by email",
    "Type a comment": "Type a comment",
    "Send portal message": "Send portal message",
    "Open timesheet": "Open timesheet",
    "Pause timer": "Pause timer",
    "Mark undone": "Mark undone",
    "Digitise": "Digitize",
    "Documents sent to digitisation": "Documents sent to digitization",
    "Followers": "Followers",
    "Start / Due date": "Start / Due date",
    "Select topic": "Select topic",
    "1 document": "1 document",
    "{0} documents": "{0} documents",
    "Download": "Download",
    "Download all": "Download all",
    "Primary contact": "Primary contact",
    "Assign as task": "Assign as task",
    "When selected, the task is sent as a task to the client": "When selected, the task is sent as a task to the client",
    "Auto finish": "Auto finish",
    "When selected, the task is marked done after client finishes it": "When selected, the task is marked done after client finishes it",
    "Add comment / message": "Add comment / message",
    "Add email": "Add email",
    "Add estimation": "Add estimation",
    "Add task field": "Add task field",
    "Add dependency": "Add dependency",
    "Drop files to upload": "Drop files to upload",
    "Task sent to client portal": "Task sent to client portal",
    "Task no longer assigned to client portal": "Task is no longer assigned to client portal",
    "Save recurring task": "Save recurring task",
    "Add to-do list": "Add to-do list",
    "Waiting for event status: {0}": "Waiting for event status: {0}",
    "Waiting for project status: {0}": "Waiting for project status: {0}",
    "Edit template task": "Edit template task",
    "Create recurring task": "Create recurring task",
    "Make a copy": "Make a copy",
    "Add topic": "Add topic",
    "Delete task": "Delete task",
    "Delete task template": "Delete task template",
    "Select task field": "Select task field",
    "No custom fields available for this client": "No custom fields available for this client",
    "task": "task",
    "recurring task": "recurring task",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Do you intend to remove yourself from {0} or do you want to delete it completely?",
    "This {1} is shared with {0}": "This {1} is shared with {0}",
    "Remove only me": "Remove only me",
    "Time has been tracked to this task.": "Time has been tracked to this task.",
    "Are you sure to delete this task?": "Are you sure to delete this task?",
    "Undefined": "Undefined",
    "COPY": "COPY",
    "On task due date": "On task due date",
    "{0} day before": "{0} day before",
    "{0} days before": "{0} days before",
    "Edit workflow": "Edit workflow",
    "Duplicate project": "Duplicate project",
    "Reset layout": "Reset layout",
    "Any time": "Any time",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 h",
    "Add notes": "Add notes",
    "Task start date": "Task start date",
    "Task due date": "Task due date",
    "Recurrence task": "Recurring task",
    "Search from one time templates": "Search from one time templates",
    "Placeholders": "Placeholders",
    "New task": "New task",
    "New recurring task": "New recurring task",
    "+1 day": "+1 day",
    "Edit comment": "Edit comment",
    "Timer is running!": "Timer is running!",
    "Continue time from {0}": "Continue time from {0}",
    "New time entry": "New time entry",
    "Load more": "Load more",
    "Are you sure to delete this time entry?": "Are you sure you want to delete this time entry?",
    "Save automated email": "Save automated email",
    "Automation": "Automation",
    "Are you sure to delete this email?": "Are you sure you want to delete this email?",
    "Are you sure you wish to send this email immediately?": "Are you sure you want to send this email immediately?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "commented",
    "Reply": "Reply",
    "Are you sure to delete this comment?": "Are you sure you want to delete this comment?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "sent a client portal message",
    "replied to task email": "replied to task email",
    "failed to send": "failed to send",
    "sent email": "sent email",
    "no one": "no one",
    "created this task.": "created this task.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "requested assistance in client portal.",
    "updated this task.": "updated this task.",
    "tracked time to this task.": "took on this task.",
    "finished this task.": "finished this task.",
    "new comment.": "new comment.",
    "reassigned this task.": "reassigned this task.",
    "assigned the task to {0}.": "assigned this task to {0}.",
    "reminder.": "reminder.",
    "deleted.": "deleted.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "Completed the task, but Uku did not auto-finish this task because not all task requirements were met.",
    "sent task to client portal": "sent this task to client portal",
    "assigned the task to client.": "assigned this task to client.",
    "assigned the task to company.": "assigned this task back to company.",
    "added attachment(s).": "added attachment(s).",
    "added a comment.": "added a comment.",
    "added a message to {0}.": "sent a message to {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "updated description.",
    "made changes to checklist.": "made changes to checklist.",
    "created this task template.": "created this task template.",
    "updated this task template.": "updated this task template.",
    "recurring task assigned.": "recurring task assigned.",
    "recurring task deleted.": "recurring task deleted.",
    "added email.": "added email.",
    "changed email.": "changed email.",
    "deleted email.": "deleted email.",
    "sent email.": "sent email.",
    "failed to send.": "failed to send email.",
    "added email": "added email",
    "changed email": "changed email",
    "deleted email": "deleted email",
    "Member / Time": "Member / Time",
    "Client/topic": "Client/topic",
    "Client/task": "Client/task",
    "Client/member": "Client/member",
    "Member/topic": "Member/topic",
    "Member/task": "Member/task",
    "Member/client": "Member/client",
    "Member/date": "Member/date",
    "Date/member": "Date/member",
    "Grouped": "Grouped",
    "Client/project": "Client/project",
    "Project/member": "Project/member",
    "Period balance": "Period balance",
    "Reset balance": "Reset balance",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Period balance has been locked and changes in tasks or time entries will no longer affect it",
    "(Without project)": "(Without project)",
    "Decline": "Decline",
    "Accept": "Accept",
    "Cancel decision": "Reset",
    "Accepted": "Accepted",
    "Declined": "Declined",
    "Report data has changed. Please update report.": "Report data has changed. Please update report.",
    "Agreed": "Agreed",
    "Non billable": "Non billable",
    "Estimation report shows based on task start date": "Estimation report shows based on task start date",
    "Export report to Excel": "Export report to Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "By default, we export the result of the selected filters and the configured columns.",
    "Add to export client custom fields": "Add to export client custom fields",
    "Save report": "Save report",
    "Export PDF": "Export PDF",
    "Export Excel": "Export Excel",
    "Extra": "Extra",
    "done": "done",
    "h": "h",
    "We have new version of": "We have a new version of",
    "Log out": "Log out",
    "Previous day": "Previous day",
    "Next day": "Next day",
    "Mark all as read": "Mark all as read",
    "Search task/client": "Search",
    "from client portal": "from client portal",
    "Hide all": "Hide all",
    "Hide for 1 hour": "Hide for 1 hour",
    "Something went wrong": "Something went wrong",
    "User authentication needed": "User authentication required",
    "Invalid rights": "Invalid rights",
    "The object cannot be found": "The object cannot be found",
    "Content too large": "Content too large",
    "An unknown error occurred": "An unknown error occurred",
    "The action requested cannot be performed": "The action requested cannot be performed",
    "Go": "Go",
    "Actual / monitoring (month)": "Actual / monitoring (month)",
    "Actual": "Actual",
    "Month": "Month",
    "I’m setting up your account": "I’m setting up your account",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.",
    "Let’s setup your company": "Let’s set up your company",
    "Name of your company": "Name of your company",
    "Size of your team?": "Size of your team?",
    "Which software are you using?": "Which software are you using?",
    "This knowledge will help us to improve Uku": "This knowledge will help us improve Uku",
    "What other software needs to be integrated?": "What other software needs to be integrated?",
    "Book a demo": "Book a demo",
    "Hi {0},": "Hi, {0},",
    "NO BOTS - ONLY HUMANS": "NO BOTS - ONLY HUMANS",
    "Start a {0} day free trial": "Start a {0} day free trial",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "\"Uku is incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "The fastest way for you to see how Uku can benefit {0} is a short {1} min call with our onboarding specialist.",
    "Hi, I'm Uku ": "Hi, I’m Uku ",
    "I help to set up your account.": "I will help to set up your account.",
    "It only takes a minute.": "It only takes a minute.",
    "Choose": "Choose",
    "Your country": "Your country",
    "Your language": "Your language",
    "Begin": "Begin",
    "Let’s become friends": "Let’s become friends",
    "Your first name": "Your first name",
    "What is your field of work?": "What is your field of work?",
    "Your field of work": "Your field of work",
    "How will you use Uku?": "How will you use Uku?",
    "How did you hear about Uku?": "How did you hear about Uku?",
    "Choose channel": "Choose channel",
    "Please specify how you heard about us": "Please specify how you heard about us",
    "Let me know Uku's new features by email": "Let me know Uku's new features by email",
    "Finish": "Finish",
    "First name is required": "First name is required",
    "Name is required": "Name is required",
    "Team size is required": "Team size is required",
    "Surname is required": "Surname is required",
    "Field is required": "Field is required",
    "I will use Uku to work together with two or more teammates.": "I will use Uku to work together with two or more teammates.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "I will use Uku by myself. This plan is free, but the features are limited.",
    "Media": "Media",
    "Through integration partner": "Through an integration partner",
    "Referral by friend": "Referral by a friend",
    "Import speeds up your clients setup, smart choice!": "Import speeds up your clients setup, smart choice!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients",
    "Last import: added {0}, updated {1}, skipped {2}": "Last import: added {0}, updated {1}, skipped {2}",
    "What's next? Correct the data of {0} clients and upload again.": "What's next? Correct the data of {0} clients and upload again.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Instead of entering clients one by one, you can use file import for a large customer base.",
    "Ignore": "Ignore",
    "NEW CLIENT": "NEW CLIENT",
    "Preview": "Preview",
    "Import started": "Import started",
    "Only new clients": "Only new clients",
    "Update data from company register": "Update data from company register",
    "If switched on, the company data is updated using the local business register": "If switched on, the company data is updated using the local business register by company registration number",
    "We did not find a match in Äriregister": "We did not find a match in Äriregister",
    "We did not find a match in Companies House": "We did not find a match in Companies House",
    "No integration yet": "No integration yet",
    "Uku match": "Uku match",
    "Business register nr.": "Business register no.",
    "Company register": "Company register",
    "Upload file": "Upload file",
    "Before uploading your file": "Before uploading your file",
    "Learn Uku’s data structure": "Learn Uku’s data structure",
    "Download and use our sample file to see exactly how we organize data in Uku": "Download and use our sample file to see exactly how we organize data in Uku",
    "Download Client Import Example": "Download Client Import Example",
    "Download Contact Import Example": "Download Contact Import Example",
    "Fill in fields": "Fill in fields",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "The only mandatory field is the company name. Make sure you’ve filled out all the necessary fields before uploading the file.",
    "Learn more about mandatory fields": "Learn more about mandatory fields",
    "Create custom fields": "Create custom fields",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.",
    "Add new custom fields": "Add new custom fields",
    "...or drag a file here": "...or drag a file here",
    "Only Excel (.xls, .xlsx) file types are supported": "Only Excel (.xls, .xlsx) file types are supported",
    "Mapping": "Mapping",
    "First row is a header": "First row is a header",
    "Add field to all clients": "Add field to all clients",
    "Add client group": "Add client group",
    "Fields for all clients": "Fields for all clients",
    "Import of {0} in progress": "Import of {0} in progress",
    "Import in progress": "Import in progress",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.",
    "Cancel import": "Cancel import",
    "Are you sure you want to cancel import?": "Are you sure you want to cancel import?",
    "Last updated": "Last updated",
    "Contracts": "Contracts",
    "Job name": "Job name",
    "Workflow name": "Workflow name",
    "Details": "Details",
    "Select jobs": "Select jobs",
    "Select task plan": "Select task plan",
    "of existing client": "of existing client",
    "You can also choose": "You can also choose",
    "existing client tasks plan": "existing client tasks plan",
    "existing predefined jobs": "existing predefined jobs",
    "create a new plan": "create a new plan",
    "Select workflow": "Select workflow",
    "existing project workflow": "existing project workflow",
    "existing workflow": "existing workflow",
    "create a new workflow": "create a new workflow",
    "New tasks template": "New tasks template",
    "to save template!": "to save template!",
    "You can also add tasks from jobs": "You can also add tasks from jobs",
    "or choose": "or choose",
    "New workflow template": "New workflow template",
    "You can also add tasks from existing workflow templates": "You can also add tasks from existing workflow templates",
    "existing event workflow": "existing event workflow",
    "Hide others": "Hide others",
    "Update all events (New tasks)": "Update all events (New tasks)",
    "Update all projects (New tasks)": "Update all projects (New tasks)",
    "Once": "Once",
    "Once a month": "Once a month",
    "Once a quarter": "Once a quarter",
    "Once a year": "Once a year",
    "Company workflow": "Company workflow",
    "Company jobs": "Company jobs",
    "Default jobs": "Default jobs",
    "ID": "ID",
    "Task title and labels": "Task title and labels",
    "Assigned and time": "Assigned and time",
    "Setup tasks for {0} event": "Setup tasks for {0} event",
    "Setup tasks for {0} project": "Setup tasks for {0} project",
    "New job": "New job",
    "Edit job": "Edit job",
    "New workflow": "New workflow",
    "Save workflow": "Save workflow",
    "Confirm task plan": "Confirm task plan",
    "Skip": "Skip",
    "Create task plan": "Create a task plan",
    "Edit task plan": "Edit task plan",
    "Confirm workflow": "Confirm workflow",
    "Client portal templates": "Client portal templates",
    "Jobs": "Jobs",
    "Workflows": "Workflows",
    "Company workflows": "Company workflows",
    "Default workflows": "Default workflows",
    "Company template saved": "Company template saved",
    "Company template created": "Company template created",
    "Format": "Format",
    "Currency": "Currency",
    "Reference number": "Reference number",
    "Invoice description": "Invoice description",
    "Summarize invoice rows": "Summarize invoice rows",
    "Summarized description": "Summarized description",
    "Reverse charge": "Reverse charge",
    "Rounding": "Rounding",
    "Time rounding will apply for each line": "Time rounding will apply for each line",
    "Rounding increment (up)": "Rounding increment (up)",
    "Reply to": "Reply to",
    "Configuration": "Configuration",
    "Invoice to parent company": "Invoice to parent company",
    "Create all invoices under parent company.": "Create all invoices under parent company.",
    "User code": "User code",
    "Default": "Default",
    "Default value will apply for each line": "Default value will apply for each line",
    "Number": "Number",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.",
    "Copy to clipboard": "Copy to clipboard",
    "Invoice previous period": "Invoice previous period",
    "Invoice period": "Invoice period",
    "Invoice next period": "Invoice next period",
    "Client primary user": "Client primary member",
    "Original client name": "Original client name",
    "invoice date year": "invoice date year",
    "last two digits of invoice date year": "last two digits of invoice date year",
    "invoice date month": "invoice date month",
    "invoice date day": "invoice date day",
    "Contract": "Contract",
    "Net total": "Net total",
    "Contract #": "Contract #",
    "Invoice #": "Invoice No.",
    "Exported": "Exported",
    "Sent": "Sent",
    "Net": "Net",
    "Add invoice": "Add invoice",
    "Change invoice number": "Change invoice number",
    "Review changes": "Review changes",
    "Please review and approve changes to the related events": "Please review and approve changes to the related events",
    "Please review and approve changes to the related projects": "Please review and approve changes to the related projects",
    "Contains": "Contains",
    "contains": "contains",
    "Exactly": "Exactly",
    "is exactly": "is exactly",
    "Greater than": "Greater than",
    "is greater than": "is greater than",
    "Less than": "Less than",
    "is less than": "is less than",
    "Range": "Range",
    "is in range of": "is in the range of",
    "is empty": "is empty",
    "Task plan": "Task plan",
    "Edit plan": "Edit plan",
    "Use task plan templates to set up tasks effectively or add a task manually": "Use task plan templates to set up tasks effectively or add a task manually.",
    "Add task manually": "Add tasks manually",
    "Quarterly": "Quarterly",
    "Export excel": "Export excel",
    "Print PDF": "Print PDF",
    "Edit jobs": "Edit jobs",
    "Replace plan tasks with job": "Replace plan tasks with job",
    "Select template": "Select template",
    "member": "member",
    "Tasks with user will be added to every selected client": "Tasks with user will be added to every selected client",
    "Add even if job already applied": "Add even if job already applied",
    "Default user": "Default user",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "This will delete all tasks from client plan and put only selected template’s tasks in it",
    "Adding template will be ready in a minute. You can continue with work.": "Added template will be ready soon. You can continue with your work.",
    "Add client": "Add client",
    "Export clients": "Export clients",
    "Export client contacts": "Export client contacts",
    "client | clients": "client | clients",
    "clients": "clients",
    "client(s) had errors": "client(s) had errors",
    "client(s) selected": "client(s) selected",
    "Contract actions": "Contract actions",
    "Edit Members": "Edit Members",
    "Edit monitoring": "Edit monitoring",
    "Your company": "Your company",
    "Edit billing": "Edit billing",
    "Activate client portal": "Activate client portal",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "After activation, you can send tasks directly to all client's contacts who have an e-mail address.",
    "Send welcome invitation to client contacts": "Send welcome invite to client contacts",
    "Who will receive an invitation?": "Who will receive an invite?",
    "Client contact who has one valid e-mail address": "Client contact who has one valid e-mail address",
    "Client contact who has the client's portal open (default for all)": "Client contact who has the client's portal open (default for all)",
    "How does the invitation work?": "How does inviting work?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.",
    "Uku client portal always informs clients by email about new tasks.": "Uku client portal always informs clients by email about new tasks.",
    "View templates": "View templates",
    "Client portal activated": "Client portal activated",
    "Company's name": "Company name",
    "Mark": "Mark",
    "Add members": "Add members",
    "Members and groups": "Members and groups",
    "Topic is required": "Topic is required",
    "Entering time is required": "Entering time is required",
    "Delete client": "Delete client",
    "Manage client fields": "Manage client fields",
    "Max 3 characters": "Max 3 characters",
    "Are you sure you wish to delete this client?": "Are you sure you want to delete this client?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "NB! Deleting client data will also delete all related tasks, time entries and client history",
    "Owner": "Owner",
    "All clients that you add under {0} will be deleted later.</div>": "All clients that you add under {0} will be deleted later.</div>",
    "Use this account for testing purposes only!": "Use this account for testing purposes only!",
    "Read more about the demo account": "Read more about the demo account",
    "Rights": "Rights",
    "Monitoring setup": "Monitoring setup",
    "Learn more about monitoring": "Learn more about monitoring",
    "selected": "selected",
    "Resend": "Resend",
    "Invoicing": "Invoicing",
    "Billing template": "Billing template",
    "New": "New",
    "Add row": "Add row",
    "Delete contract": "Delete contract",
    "Product / description": "Product / description",
    "Qty": "Qty",
    "Product placeholders": "Product placeholders",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Template saved",
    "Warning": "Warning",
    "Would you like to apply these changes to all clients using this contract template?": "Would you like to apply these changes to all clients using this contract template?",
    "Yes, apply to all clients": "Yes, apply to all clients",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "You have made changes to the time period that this billing contract applies to. This may change how affected not-billed services in the past and future will be invoiced. Please confirm that this change was intentional.",
    "Are you sure to delete this template?": "Are you sure you want to delete this template?",
    "Save template": "Save template",
    "Save as template": "Save as template",
    "Please note all changes made to contract will be lost": "Please note all changes made to contract will be lost",
    "Add contract": "Add contract",
    "Manage contract templates": "Manage contract templates",
    "Edit account details": "Edit account details",
    "Country is required": "Country is required",
    "Postal code": "ZIP code",
    "State": "State",
    "Uku is set up according to the field of work.": "Uku is set up according to the field of work.",
    "Size of the team": "Size of the team",
    "Website": "Website",
    "Delete account": "Delete account",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Yes, delete the account with all related data such as clients, tasks, and all history",
    "These invoices cannot be sent. Check their status or error messages.": "These invoices cannot be sent. Check their status or error messages.",
    "Please confirm that you wish to proceed.": "Please confirm that you wish to proceed.",
    "Sending invoice | Sending invoices": "Sending invoice | Sending invoices",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "You are about to e-mail this invoice to the customer. | You are about to e-mail these invoices to customers.",
    "Error in calculating invoice": "Error in calculating invoice",
    "Error in importing invoice": "Error in importing invoice",
    "Error in creating invoice": "Error in creating invoice",
    "Error in exporting invoice": "Error in exporting invoice",
    "Error in sending invoice": "Error in sending invoice",
    "Calculating invoice": "Calculating invoice",
    "Creating invoice": "Creating invoice",
    "Exporting invoice": "Exporting invoice",
    "Importing invoice": "Importing invoice",
    "Sending invoice": "Sending invoice",
    "Clear errors": "Clear errors",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.",
    "Delete invoice | Deleting invoices": "Delete invoice | Deleting invoices",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Nothing in invoices",
    "Please make sure you have setup recurring billing for your clients": "Please make sure you have set up recurring billing for your clients",
    "Draft": "Draft",
    "Approval": "Approval",
    "Created": "Created",
    "Coming soon": "Coming soon",
    "Selected invoices and related product info will be sent to accounting system.": "Selected invoices and related product info will be sent to the accounting system.",
    "Piece": "Piece",
    "Hour": "Hour",
    "Delete row": "Delete row",
    "Out of ": "Out of ",
    " can be created": " can be created",
    "For ": "For ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.",
    "Invoice date will be set to today.": "Invoice date will be set to today.",
    "Uku is about to create": "Uku is about to create",
    " selected row, only | selected row, only ": " selected row, only | selected row, only ",
    " invoice | invoices": " invoice | invoices",
    "These invoices cannot be exported. Check their status or error messages.": "These invoices cannot be exported. Check their status or error messages.",
    "Exporting invoice | Exporting invoices": "Exporting invoice | Exporting invoices",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Download PDF",
    "Create invoice": "Create invoice",
    "Update status from {0}": "Update status from {0}",
    "Show all lines": "Show all lines",
    "Calculate invoice": "Calculate invoice",
    "Loading invoice...": "Loading invoice...",
    "Invalid Scoro credentials": "Invalid Scoro credentials",
    "Please confirm the changes you have made to this invoice.": "Please confirm the changes you have made to this invoice.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.",
    "Invoice number already exists! Please confirm to save anyway.": "Invoice number already exists! Please confirm to save anyway.",
    "Error in data": "Error in data",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.",
    "Creation date": "Creation date",
    "{0} days after": "{0} days after",
    "{0} day after": "{0} day after",
    "right away when": "right away on",
    "start date": "start date",
    "due date": "Due date",
    "finished": "finished",
    "Entries count": "Entries count",
    "Entries excluding sales": "Entries excluding sales",
    "Entries excluding bank": "Entries excluding bank",
    "Entries excluding documents": "Entries excluding documents",
    "Documents (sales and purchases)": "Documents (sales and purchases)",
    "Cash entries": "Cash entries",
    "VAT entries": "VAT entries",
    "Stock entries": "Stock entries",
    "Sale entries": "Sale entries",
    "Purchase entries": "Purchase entries",
    "Bank entries": "Bank entries",
    "Ledger entries": "Ledger entries",
    "Depreciation entries": "Depreciation entries",
    "Entry lines count": "Entry lines count",
    "Transaction create": "Transaction create",
    "Transaction update": "Transaction update",
    "Purchase invoice create": "Purchase invoice create",
    "Purchase invoice update": "Purchase invoice update",
    "Sales invoice create": "Sales invoice create",
    "Sales invoice update": "Sales invoice update",
    "Financial entry create": "Financial entry create",
    "Financial entry update": "Financial entry update",
    "Expense row create": "Expense row create",
    "Expense row update": "Expense row update",
    "Depreciation create": "Depreciation create",
    "Depreciation update": "Depreciation update",
    "Person count": "Person count",
    "Fixed assets": "Fixed assets",
    "Company owner": "Company owner",
    "Activity": "Activity",
    "Oldest first": "Oldest first",
    "Newest first": "Newest first",
    "Quantity as time": "Quantity as time",
    "Quantity as number": "Quantity as number",
    "Quantity as time in number format": "Quantity as time in number format",
    "No rounding": "No rounding",
    "min": "min",
    "hour": "hour",
    "Last day of month": "Last day of month",
    "Invoice line": "Invoice line",
    "Task time total (per member)": "Task time total (per member)",
    "Time entry": "Time entry",
    "Task finish date": "Task finish date",
    "Create separately": "Create separately",
    "Merge into one": "Merge into one",
    "No minimum": "No minimum",
    "{0} minute": "{0} minute",
    "{0} minutes": "{0} minutes",
    "{0} hour": "{0} hour",
    "{0} hours": "{0} hours",
    "English": "English",
    "Estonian": "Estonian",
    "Danish": "Danish",
    "Lithuanian": "Lithuanian",
    "Russian": "Russian",
    "Finnish": "Finnish",
    "Swedish": "Swedish",
    "Norwegian": "Norwegian",
    "Latvian": "Latvian",
    "Bulgarian": "Bulgarian",
    "German": "German",
    "Spanish": "Spanish",
    "Polish": "Polish",
    "Field: ": "Field: ",
    "Normal hours": "Normal hours",
    "Year": "Year",
    "Estonia": "Estonia",
    "Finland": "Finland",
    "Poland": "Poland",
    "User": "User",
    "None": "None",
    "Error!": "Error!",
    "Pending": "Pending",
    "Finished": "Finished",
    "Text": "Text",
    "Choice": "Choice",
    "Yes/No": "Yes/No",
    "Integer": "Integer",
    "Multiple choice": "Multiple choice",
    "URL": "URL",
    "Multiple users": "Multiple users",
    "Multiline text": "Multiline text",
    "Must be a integer": "Must be an integer",
    "Must be a date": "Must be a date",
    "Must be a valid e-mail address": "Must be a valid e-mail address",
    "Unknown choice": "Unknown choice",
    "Some errors occurred:": "A few errors occurred",
    "Unknown network error": "Unknown network error",
    "Could not connect to the service": "Could not connect to the service",
    "Reload this page": "Please reload this page",
    "Invoice paid": "Invoice paid",
    "Annulled": "Cancelled",
    "Processing": "Processing",
    "You are about to deactivate this app.": "You are about to deactivate this app.",
    "You are about to disconnect this app.": "You are about to disconnect this app.",
    "Do you also want to activate billing to get the most out of Uku?": "Do you also want to activate billing to get the most out of Uku?",
    "Invoice": "Invoice",
    "Clients - Monitoring": "Clients - Monitoring",
    "Links": "Links",
    "New template": "New template",
    "Import Clients from Excel": "Import clients from Excel",
    "Importer": "Importer",
    "Import clients from Excel": "Import clients from Excel",
    "Account settings": "Account settings",
    "Empty": "Empty",
};
export default translations